import { useMemo } from "react";
import { IconProps } from "./Linkedin";
import "./Logo.css"

interface LogoProps extends IconProps {
    withText?: boolean
    colorText?: string,
    colorLogo?: string
}

export const Logo = (({ className, withText, colorLogo, colorText }: LogoProps) => {

    const showText = useMemo(() => {
        if (withText) {
            return (
                <div className={ `${className} logo_cont d-flex flex-row justify-content-start align-items-center m-0 p-0 w-100`}>
                    <div className=" logo_text_icon p-0 m-0">
                    <svg viewBox="0 0 760.67 313.36"  className={"logo_icon"}>
                      <polygon points="264.17 -314.5 137.14 -188.51 611.08 282.67 738.11 156.68 264.17 -314.5" fill={colorLogo} />
                      <polygon points="-23.19 347.22 103.42 473.63 264.91 314.13 138.29 187.73 -23.19 347.22" fill={colorLogo} />
                      <polygon points="26.09 -237.48 -100.94 -111.49 858.5 842.35 985.53 716.35 26.09 -237.48" fill={colorLogo} />
                    </svg>
                    </div>
                    <div className=" logo_text_title d-flex flex-row align-items-center justify-content-start p-0 m-0 ">
                    <p style={{color:colorText}} className=' '>Innovation Match</p>
                    </div>
                </div>
            )
        } else {
            return (
                <svg viewBox="0 0 760.67 313.36" className={className}>
                    <polygon points="264.17 -314.5 137.14 -188.51 611.08 282.67 738.11 156.68 264.17 -314.5" fill={colorLogo} />
                    <polygon points="-23.19 347.22 103.42 473.63 264.91 314.13 138.29 187.73 -23.19 347.22" fill={colorLogo} />
                    <polygon points="26.09 -237.48 -100.94 -111.49 858.5 842.35 985.53 716.35 26.09 -237.48" fill={colorLogo} />
                </svg>
            )
        }

    }, [withText, colorLogo, className,colorText])


    return showText
})